import { useCallback, useEffect, useRef, useState } from 'react';
import { DeliverySelection, quoteStoreDelivery, saveDeliveryQuote } from '../Utils/deliveryQuote';

export function useDeliveryQuote(empresaid: string | undefined, selection: DeliverySelection, onQuote: (taxa: string, tempo: string) => void) {
  const key = JSON.stringify(selection);
  const current = useRef({ empresaid, key, onQuote });
  current.current = { empresaid, key, onQuote };
  const request = useRef<{ sequence: number; controller?: AbortController }>({ sequence: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const refresh = useCallback(async (validateHours = false) => {
    const active = current.current;
    const selected: DeliverySelection = JSON.parse(active.key);
    if (!active.empresaid || !selected.endereco) return null;
    const sequence = ++request.current.sequence;
    request.current.controller?.abort();
    const controller = new AbortController();
    request.current.controller = controller;
    setLoading(true); setError('');
    try {
      const quote = await quoteStoreDelivery(active.empresaid, selected, controller.signal, validateHours || Boolean(selected.agendamento));
      if (controller.signal.aborted || sequence !== request.current.sequence || current.current.key !== active.key || current.current.empresaid !== active.empresaid) return null;
      saveDeliveryQuote(quote);
      current.current.onQuote(quote.taxa, quote.tempo);
      return quote;
    } catch (failure) {
      if (!controller.signal.aborted && sequence === request.current.sequence) setError(failure instanceof Error ? failure.message : 'Não foi possível atualizar a entrega.');
      return null;
    } finally {
      if (sequence === request.current.sequence) setLoading(false);
    }
  }, []);
  useEffect(() => {
    const active = request.current;
    if (empresaid && JSON.parse(key).endereco) refresh();
    else { setLoading(false); setError(''); }
    return () => { ++active.sequence; active.controller?.abort(); };
  }, [empresaid, key, refresh]);
  return { loading, error, refresh };
}
